import { Container, Divider } from "@mui/material";

import ContactUs from "./components/ContactUs";
import QuickAccessButtons from "./components/QuickAccessButtons";
import SpecialCoins from "./components/SpecialCoins";
import { useEffect } from "react";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "routes/paths";

function Home() {
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();

  useEffect(() => {
    if (!isMobileView) {
      navigate(ROUTE_PATHS.market);
    }
  }, [isMobileView, navigate]);

  return (
    <Container>
      <SpecialCoins />

      <QuickAccessButtons />

      <Divider sx={{ margin: "16px 0" }} />

      <ContactUs />
    </Container>
  );
}

export default Home;
